<template>
  <div class="newboxb">
    <div class="boxOne dn-content-bg">
      <el-form ref="form" :model="form" size="small" class="carForm">
        <el-form-item label="车间名称" style="width:300px">
          <!-- style="text-align: left;" -->
          <el-select v-model="form.measureName" placeholder="请选择" @change="selectCar">
            <el-option v-for="item in viewmeasureTable" :key="item.measureId" :label="item.measureName" :value="item.measureId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否强制写入:" style=" width: 200px;margin-right: 8px;text-align: left;">
          <!-- style="text-align: left;" -->
          <el-select v-model="froce" placeholder="请选择" style="width:100px;">
            <el-option v-for="item in froceData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <!-- <data-type
            ref="search"
            @getData="getData"
            :timeInterval="timeInterval"
            :timeType="timeType"
            ></data-type> -->
          <time-search ref="timeSearch" :control="{ data: timeData }" @timeControlClick="getData">
          </time-search>
        </el-form-item>
        <el-button size="small" type="primary" style="height: 30px;line-height: 0px;margin-top: 4px;" @click="addCar">添加产量</el-button>
      </el-form>
      <el-table :data="tableData" height="610" border :header-cell-style="tableHeaderColor">
        <el-table-column prop="time" label="日期" align="center" sortable :formatter="timeDataOne"></el-table-column>
        <el-table-column prop="value" label="值" align="center" sortable></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pageNew" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.pageIndex" :page-sizes="page.pageSizes" :page-size="page.size" :layout="layout" :total="page.total"></el-pagination>
      <!-- 编辑弹窗 -->
      <el-dialog title="编辑产量" :visible.sync="updateDig" :destroy-on-close="true" :close-on-click-modal="false" width="560px">
        <el-form ref="form" :model="updateForm" label-width="100px">
          <el-form-item label="时间">
            <el-date-picker v-model="updateForm.time" type="date" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy/MM/dd HH:mm:ss" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="值" style="width:320px">
            <el-input v-model="updateForm.value"></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="updateCar" class="updatabutto">保存</el-button>
      </el-dialog>
      <!-- 车间弹窗 -->
      <el-dialog title="选择计量点" :visible.sync="open" width="900px" :destroy-on-close="true" :close-on-click-modal="false">
        <view-diolog v-if="open" :viewtab="viewtab" @clicktable="gettablevalue" :viewId="viewId"></view-diolog>
        <div slot="footer" class="dialog-footer" style="margin-right:350px">
          <el-button type="primary" @click="okselect" class="btn">确 定</el-button>
          <el-button @click="open = false" class="cancel">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 新增弹窗 -->
      <el-dialog :title="carTitle" :visible.sync="carDig" :destroy-on-close="true" :close-on-click-modal="false" style="text-align: left;">
        <el-form ref="form" :model="digForm" label-width="120px" class="cldCarForm">
          <el-form-item label="车间名称" style="text-align: left;">
            <label :style="digForm.measureId=='请选择车间'?'color:#b7adad':'color:#111'">{{digForm.measureName}}</label>
            <el-button size="small" type="primary" style="margin-left:30px" @click="open=true">选择车间</el-button>
          </el-form-item>
          <el-row class="merge">
            <el-form-item label="时间粒度">
              <el-select v-model="digForm.grading" placeholder="请选择" style="width:150px">
                <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间">
              <div style="display: inline-block;">
                <el-date-picker style="width:180px;" v-model="digForm.time[0]" :picker-options="pickerOptions" type="datetime" placeholder="选择日期时间"></el-date-picker>
                <label style="padding: 0px 10px;">-</label>
                <el-date-picker style="width:180px;" v-model="digForm.time[1]" :picker-options="pickerOptions" type="datetime" placeholder="选择日期时间"></el-date-picker>
              </div>
              <el-button :disabled="this.digForm.measureId==''||this.digForm.measureId=='请选择车间'?true:false" size="small" type="primary" style="margin-left:30px" @click="gettime">确定</el-button>
            </el-form-item>
          </el-row>
        </el-form>
        <el-table :data="tableDataLittle" style="margin-top:15px;" height="400" border :header-cell-style="tableHeaderColor">
          <el-table-column prop="time" label="日期"></el-table-column>
          <el-table-column prop="value" label="值">
            <template v-slot="scope">
              <el-input oninput="value=value.replace(/[^\d^\.]/g,'')" size="small" v-model="scope.row.value" placeholder="请输入内容" :ref="scope.$index" @keyup.enter.native="enterchanger(scope.$index, scope.row, $event)" @change="handleEdit(scope.$index, scope.row)"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" @click="setQuantitiesDay" class="updatabuttom">保存</el-button>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import * as utils from "@/utils/index.js";
import handleData from "@/utils/handleData.js";
import TimeSearch from '@/components/common/TimeSearch.vue'
import ViewDiolog from "./page/ViewDiolog.vue";
import { isNull, isUndefined } from "util";
import * as fpg from "@/utils/fpg.js";
import dateTool from "@/utils/dateTool";
let allTimeData = [
  {
    type: 'day',
    label: '日'
  },
  {
    type: 'month',
    label: '月'
  },
  {
    type: 'year',
    label: '年'
  }
]
export default {
  components: {
    TimeSearch, ViewDiolog
  },

  data () {
    return {
      timeData: allTimeData,
      viewtab: {
        all: true,
        framework: true,
        view: true,
        class: true
      },
      open: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        }
      },
      froce: 1,
      froceData: [
        { id: 0, name: "否" },
        { id: 1, name: "是" },
      ],
      showpointcode: true,
      showpointcode1: false,
      tablevalue: {},
      tablevalue1: {},
      form: {
        measureId: "请选择车间",
        measureName: "请选择车间",
        pointCode: "",
        pointNumber: "",
        grading: "",
        time: [],
        endtime: "",
        viewId: ""
      },
      digForm: {
        measureId: "请选择车间",
        measureName: "请选择车间",
        pointCode: "",
        pointNumber: "",
        grading: "",
        time: [],
        endtime: "",
        viewId: ""
      },
      viewId: "",
      options1: [
        {
          value: "hour",
          label: "时"
        },
        {
          value: "day",
          label: "日"
        },
        {
          value: "month",
          label: "月"
        },
        {
          value: "year",
          label: "年"
        }
      ],
      options4: [
        {
          value: "hour",
          label: "时"
        }
      ],
      tableData: [],
      tableData1: [],
      carTitle: "新增车间",
      carDig: false,
      tableDataLittle: [],
      viewmeasureTable: [],//车间数据
      elem: {
        dateType: '',
        fromDate: '',
        toDate: ''
      },
      timeInterval: "toDay",
      timeType: [
        { value: "0", label: "日" },
        { value: "2", label: "月" },
        // { value: "3", label: "时段" },
        { value: "5", label: "年" }
      ],
      //分页栏
      page: {
        pageSizes: [10, 20, 50, 100, 500, 1000], //每页显示条目个数
        size: 10,
        pageIndex: 1,
        total: 0
      },
      layout: "total,  prev, pager, next,sizes",
      updateDig: false,
      updateForm: {
        time: '',
        value: ""
      }
    };
  },
  created () {
    let vm = this
    vm.getMyFrontEndPageCustomParam();
  },
  methods: {
    //获取页面自定义参数
    getMyFrontEndPageCustomParam () {
      let vm = this;
      vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam("0", "/analysis/productionInput", "param")
        .then(res => {
          console.log(res.data)
          res.data.forEach(item => {
            if (item.param == 'param') {
              let temData = JSON.parse(item.value);
              vm.form.pointCode = temData[0].pointCode;
              vm.form.pointNumber = temData[0].pointNumber;
              vm.digForm.pointCode = temData[0].pointCode;
              vm.digForm.pointNumber = temData[0].pointNumber;
              vm.viewId = temData[0].viewId;
              vm.getViewTreeNodes(vm.viewId)
            }
          })
        });
    },
    //获取视图表格
    getViewTreeNodes (id) {
      let vm = this
      vm.$api.view.getViewTreeNodes(id).then(res => {
        if (res) {
          vm.viewmeasureTable = res.data;
          vm.form.measureId = res.data[0].measureId
          vm.form.measureName = res.data[0].measureName
          vm.$nextTick(() => {
            let time = new Date();
            let startTime = dateTool.format(time, "yyyy-MM-dd ") + "00:00:00";
            time.setDate(time.getDate() + 1);
            let endTime = dateTool.format(time, "yyyy-MM-dd") + " 00:00:00";
            vm.elem = {
              dataType: "1",
              dateType: "day",
              endTime: endTime,
              startTime: startTime,
            };
            vm.getData(vm.elem)
          });
        }
      });
    },
    //选择车间名称
    selectCar (val) {
      this.form.measureId = val
    },
    //编辑操作列
    handleClick (row) {
      let vm = this
      vm.updateDig = true
      vm.updateForm.time = row.time
      vm.updateForm.value = row.value
    },
    // //编辑产量保存
    updateCar () {
      let vm = this
      let api = []
      let values = [];
      values.push(vm.updateForm.value)
      console.log(vm.elem.dateType)
      if (vm.updateForm.value == "") {
        vm.$message({
          message: "value不能为空！",
          type: "warning"
        });
        return;
      }
      vm.$confirm("此操作将永久覆盖数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(122222)
          if (vm.elem.dateType == "day") {
            vm.$api.quantity
              .setQuantitiesHour(
                vm.form.measureId,
                vm.form.pointCode,
                vm.form.pointNumber,
                "",
                vm.updateForm.time,
                values,
                vm.froce
              )
              .then(res => {
                if (res.success) {
                  vm.$message({
                    message: res.msg,
                    type: "success"
                  });
                  vm.getData(vm.elem)
                  vm.updateDig = false
                } else {
                  vm.$message({
                    message: res.msg,
                    type: "warning"
                  });
                  return;
                }
              });
          } else if (vm.elem.dateType == "month") {
            vm.$api.quantity
              .setQuantitiesDay(
                vm.form.measureId,
                vm.form.pointCode,
                vm.form.pointNumber,
                "",
                vm.updateForm.time,
                values,
                vm.froce
              )
              .then(res => {
                if (res.success) {
                  vm.$message({
                    message: res.msg,
                    type: "success"
                  });
                  vm.getData(vm.elem)
                  vm.updateDig = false
                } else {
                  this.$message({
                    message: res.msg,
                    type: "warning"
                  });
                  return;
                }
              });
          } else if (vm.elem.dateType == "year") {
            vm.$api.quantity
              .setQuantitiesMonth(
                vm.form.measureId,
                vm.form.pointCode,
                vm.form.pointNumber,
                "",
                vm.updateForm.time,
                values,
                vm.froce
              )
              .then(res => {
                if (res.success) {
                  vm.$message({
                    message: res.msg,
                    type: "success"
                  });
                  vm.getData(vm.elem)
                  vm.updateDig = false
                } else {
                  vm.$message({
                    message: res.msg,
                    type: "warning"
                  });
                  return;
                }
              });
          }
        })
        .catch(() => {
          consoel.log(11111)
          vm.$message({
            type: "info",
            message: "已取消修改"
          });
        });
    },
    tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
      //改表头颜色
      if (rowIndex === 0) {
        return "background-color: #F3F3F3;color: #666;";
      }
    },
    //生产时间段表格
    gettime () {
      let vm = this
      let form = vm.digForm
      if (
        form.grading == "" ||
        form.time == [] ||
        form.time == null ||
        form.time.length == 0
      ) {
        alert("请选择时间粒度和日期");
        return;
      }
      var date1 = new Date(form.time[0]); //开始时间
      var date2 = new Date(form.time[1]); //结束时间
      var date3 = date2 - date1; //时间差的毫秒数
      if (form.grading == "hour") {
        let date4 = fpg.getMatchTime1(
          form.time[0],
          form.time[1],
          "0"
        );
        vm.tableDataLittle = date4;
      } else if (form.grading == "day") {
        let date4 = handleData.createXData(
          "3",
          form.time[0],
          form.time[1],
          true
        );
        vm.tableDataLittle = date4;
      } else if (form.grading == "month") {
        let days = Math.floor((date3 / (24 * 3600 * 1000)) * 30);
        if (days >= 900) {
          let date4 = handleData.createXData(
            "5",
            form.time[0],
            form.time[1],
            true
          );
          let hash = {};
          const data2 = date4.reduce((preVal, curVal) => {
            hash[curVal.time]
              ? ""
              : (hash[curVal.time] = true && preVal.push(curVal));
            return preVal;
          }, []);
          vm.tableDataLittle = data2;
        } else {
          let date4 = dateTool.format(new Date(form.time[0]), "yyyy-MM");
          let data4 = [
            {
              time: date4,
              value: ""
            }
          ];
          vm.tableDataLittle = data4;
        }
      } else if (form.grading == "year") {
        let date4 = dateTool.format(new Date(form.time[0]), "yyyy");
        let date5 = dateTool.format(new Date(form.time[1]), "yyyy");
        let data4 = [];
        if (date4 != date5) {
          for (let i = date4; i <= date5; i++) {
            data4.push({
              time: i,
              value: ""
            });
          }
          vm.tableDataLittle = data4;
        } else {
          let data4 = [
            {
              time: date4,
              value: ""
            }
          ];
          vm.tableDataLittle = data4;
        }
      }
    },
    handleEdit (index, row) { },
    enterchanger (index, row, e) {
      e.target.blur();
      // // TODO  需要对最后一个input做判断
      if (index + 1 == this.tableData.length) {
        return;
      } else {
        this.$refs[index + 1].focus();
      }
    },
    gettablevalue (val) {
      let vm = this
      vm.tablevalue.measureId = val.id;
      vm.tablevalue.measureName = val.name;
    },
    okselect () {
      let vm = this
      if (JSON.stringify(this.tablevalue) == "{}") {
        vm.$message({
          message: "请选择车间！",
          type: "warning"
        });
        return;
      } else {
        if (vm.carDig) {
          vm.digForm.measureId = vm.tablevalue.measureId;
          vm.digForm.measureName = vm.tablevalue.measureName;
        }
        vm.open = false;
        setTimeout(() => {
          vm.tablevalue = {};
        }, 10);
      }
    },
    //查询数据
    getData (e) {
      let vm = this
      vm.elem = e
      vm.getTableData(1)
    },
    //获取数据
    getTableData (pageIndex) {
      let vm = this
      let form = JSON.parse(JSON.stringify(vm.form))
      let startTime = vm.elem.startTime
      let endTime = vm.elem.endTime
      let api = []
      if (
        form.measureId == "" ||
        form.measureName == "" ||
        form.pointCode == "" ||
        form.pointNumber == ""
      ) {
        vm.$message({
          message: "数据不能为空！",
          type: "warning"
        });
        return;
      }
      if (vm.elem.dateType == "day") {
        api.push(vm.$api.quantity
          .getQuantityHour(
            form.measureId,
            startTime,
            endTime,
            form.pointCode,
            form.pointNumber,
            ""
          ))
      } else if (vm.elem.dateType == "month") {
        api.push(vm.$api.quantity.getQuantityDay(
          form.measureId,
          startTime,
          endTime,
          [],
          form.pointCode,
          form.pointNumber,
        ))
      } else {
        api.push(vm.$api.quantity.getQuantityMonth(
          form.measureId,
          startTime,
          endTime,
          form.pointCode,
          form.pointNumber,
          ""
        ))
      }
      Promise.all(api).then(res => {
        let resData
        if (res[0].success) {
          if (vm.elem.dateType == 'month') {
            resData = res[0].data[0]
          } else {
            resData = res[0].data
          }
          console.log(resData)
          let userPage = utils.toPage(resData, pageIndex, vm.page.size);
          vm.tableData = userPage.arr;
          vm.page.total = userPage.total;
          vm.page.pageIndex = pageIndex;
        }
      }).catch(error => {
        vm.$message.error(error.data.msg);
      });
    },
    //改变页面大小处理
    handleSizeChange (val) {
      this.page.size = val;
      this.getTableData(1);
    },
    //上下一页
    handleCurrentChange (val) {
      this.getTableData(val);
    },
    formatterdata (e) {
      if (e.value == "") {
        return null;
      } else {
        return e.value;
      }
    },
    //新增产量
    addCar () {
      let vm = this
      vm.carDig = true
      vm.tableDataLittle = []
      vm.digForm.grading = '';
      vm.digForm.time = [];
      vm.digForm.measureName = ''
      vm.digForm.measureId = ''
    },
    //保存新增
    setQuantitiesDay () {
      let vm = this
      let values = [];
      vm.tableDataLittle.map(item => {
        let value = item.value == "" ? null : parseFloat(item.value);
        values.push(value);
      });
      if (
        vm.digForm.measureId == "" ||
        vm.digForm.measureName == "" ||
        vm.digForm.pointCode == "" ||
        vm.digForm.pointNumber == "" ||
        vm.tableDataLittle.length == 0
      ) {
        vm.$message({
          message: "数据不能为空！",
          type: "warning"
        });
        return;
      }
      vm.$confirm("此操作将永久覆盖数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (vm.digForm.grading == "hour") {
            vm.$api.quantity
              .setQuantitiesHour(
                vm.digForm.measureId,
                vm.digForm.pointCode,
                vm.digForm.pointNumber,
                "",
                dateTool.format(new Date(vm.digForm.time[0]), "yyyy-MM-dd hh:mm:ss"),
                values,
                vm.froce
              )
              .then(res => {
                if (res.success) {
                  vm.$message({
                    message: res.msg,
                    type: "success"
                  });
                  vm.getData(vm.elem)
                  vm.carDig = false
                } else {
                  vm.$message({
                    message: res.msg,
                    type: "warning"
                  });
                  return;
                }
              });
          } else if (vm.digForm.grading == "day") {
            vm.$api.quantity
              .setQuantitiesDay(
                vm.digForm.measureId,
                vm.digForm.pointCode,
                vm.digForm.pointNumber,
                "",
                dateTool.format(new Date(vm.digForm.time[0]), "yyyy-MM-dd hh:mm:ss"),
                values,
                vm.froce
              )
              .then(res => {
                if (res.success) {
                  vm.$message({
                    message: res.msg,
                    type: "success"
                  });
                  vm.getData(vm.elem)
                  vm.carDig = false
                } else {
                  this.$message({
                    message: res.msg,
                    type: "warning"
                  });
                  return;
                }
              });
          } else if (vm.digForm.grading == "month") {
            console.log("进来了")
            vm.$api.quantity
              .setQuantitiesMonth(
                vm.digForm.measureId,
                vm.digForm.pointCode,
                vm.digForm.pointNumber,
                "",
                dateTool.format(new Date(vm.digForm.time[0]), "yyyy-MM-dd hh:mm:ss"),
                values,
                vm.froce
              )
              .then(res => {
                if (res.success) {
                  vm.$message({
                    message: res.msg,
                    type: "success"
                  });
                  vm.getData(vm.elem)
                  vm.carDig = false
                } else {
                  vm.$message({
                    message: res.msg,
                    type: "warning"
                  });
                  return;
                }
              });
          } else if (vm.digForm.grading == "year") {
            vm.$api.quantity
              .setQuantitiesYear(
                vm.digForm.measureId,
                vm.digForm.pointCode,
                vm.digForm.pointNumber,
                "",
                dateTool.format(new Date(vm.digForm.time[0]), "yyyy-MM-dd hh:mm:ss"),
                values,
                vm.froce
              )
              .then(res => {
                if (res.success) {
                  vm.$message({
                    message: res.msg,
                    type: "success"
                  });
                  vm.getData(vm.elem)
                  vm.carDig = false
                } else {
                  vm.$message({
                    message: res.msg,
                    type: "warning"
                  });
                  return;
                }
              });
          }
        })
        .catch(() => {
          vm.$message({
            type: "info",
            message: "已取消修改"
          });
        });
    },
    //匹配时间
    timeDataOne (row, column, cellValue, index) {
      if (this.elem.dateType == "day") {
        return row.time
      } else if (this.elem.dateType == 'month') {
        return row.time.slice(0, 10)
      } else {
        return row.time.slice(0, 7)
      }
    }
  },
};
</script>
<style lang="css" scoped>
/* .newboxb>>>.time-warp {
        width: 100%;
        height: 100%;
        padding: 0px !important;
        box-sizing: border-box;
        align-items: center;
        display: flex;
    } */
.time-warp {
  width: 100%;
  height: 100%;
  padding: 0px !important;
  align-items: center;
  margin-right: 4px;
  display: flex;
}
</style>
<style lang="css" scoped>
.newboxb >>> .el-dialog {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  text-align: left;
}
</style>
<style scoped lang="scss">
.newboxb {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  color: #000;
}
.boxOne {
  padding: 14px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.carForm {
  display: flex;
}
.updatabuttom {
  margin-top: 30px;
}
.updatabutto {
  margin-left: 190px;
}
.merge {
  display: flex;
}
.newboxb .timeselect {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0 !important;
  border: none !important;
  border-radius: 5px;
}
.pageNew {
  text-align: right;
  padding: 14px 0px 0px 0px;
}
.newboxb ::v-deep .el-input--small .el-input__inner {
  height: 36px !important;
  line-height: 36px !important;
}
</style>